import React from 'react'
import client from '../../assets/client.svg'
import transaction from '../../assets/transaction.svg'
import cashPoint from '../../assets/cashPoint.svg'
import message from '../../assets/message.svg'
import numb from '../../assets/numbers.png'
import styles from './Numbers.module.css'
import Customer from '../esteemedCustomer/Customer'


const Numbers = () => {
  const numbers = [
    {
      icon: client,
      number: '670+',
      title: 'clients'
    },
    {
      icon: transaction,
      number: '980+',
      title: 'transactions'
    },
    {
      icon: cashPoint,
      number: '670+',
      title: 'cash point'
    },
  ]
  return (
    <>
    <section  className='mt-[46px] md:mt-[116px]' >
          <h1 className='text mb-[46px] md:mb-[107px]'>Our Numbers</h1>
          <section className=' lg:pb-[106px] pb-[37px]' style={{
            backgroundImage: `url(${numb})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat'
            }}>
              <div className='container w-full xl:pl-[61px] xl:pr-[57px]  '>
                  <div className='flex flex-col lg:flex-row justify-center gap-y-[106px] xl:gap-x-[50px] text-white '>
                        {numbers.map((number, i) => (
                            <div className='xl:w-[340px] xl:h-[60px] md:justify-around mt-[46px] lg:mt-[149px] flex flex-col items-center xl:justify-center' key={i}>
                                  <div>
                                      <img src={number.icon} alt="/" />
                                  </div>
                                  <div className='mt-[5px] xl:mt-[20px] h-[72px]'>
                                    <h1 className='text-[40px]  leading-[60px]'>{number.number}</h1>
                                  </div>
                                  <div className='mt-[5px] xl:mt-[20px] h-[42px]'>
                                    <p className='capitalize  text-[24px] leading-[42px] font-medium'>{number.title}</p>
                                  </div>
                          </div>
                        ))}
                       
                  </div>  
                  <div className='text-white px-[20px] md:px-0'>
                        <h1 className='text-[22px] lg:text-[32px] mt-[126px] lg:mt-[173px] leading-[28px] lg:leading-[40px] text-center '>Our Newsletter</h1>
                        <h3 className='text-[14px] lg:text-[16px] mt-[20px] leading-[20px] lg:leading-[24px] text-center tracking-[0.001em]'>Keep in touch</h3>
                        <p className='md:w-[618px] mx-auto text-[14px] lg:text-[16px] mt-[20px] leading-[24px] lg:leading-[24px] text-center font-medium tracking-[0.005em] '>Sign up to our Newletter subscription and be the first to know about important news & amazing offers and discount</p>
                  </div>   
                  <div className='flex justify-center mt-[63px] lg:mt-[79px] px-[10px] md:px-0'>
                        <div className={`w-[324px] lg:w-[507px] h-[44px]  ${styles.message} ${styles.input} flex bg-primary overflow-hidden`}>
                            <div className={`w-[52px] h-[44px] flex items-center justify-center`}>
                                <img className='w-[20px] h-[16px]' src={message} alt="/" />
                            </div>
                                <input className={`flex-1 ${styles.input} overflow-hidden px-3 outline-none`} type="text" />
                        </div>
                  </div>
                  <div className='flex justify-center mt-[20px] md:mt-[-30px] lg:mt-[-40px]'>
                      <button className='btn'>Subscribe Now</button>
                  </div>
              </div>
          </section>
    </section>
    <Customer />
    </>
  )
}

export default Numbers